var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12145_1659)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 45,
    fill: "url(#paint0_radial_12145_1659)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 45,
    fill: "url(#paint1_linear_12145_1659)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8625 64.05C41.6625 62.7 40.7188 61.175 40.0312 59.475C39.3438 57.775 39 55.95 39 54C39 51.925 39.3937 49.975 40.1812 48.15C40.9687 46.325 42.0375 44.7375 43.3875 43.3875C44.7375 42.0375 46.325 40.9687 48.15 40.1812C49.975 39.3937 51.925 39 54 39C56.075 39 58.025 39.3937 59.85 40.1812C61.675 40.9687 63.2625 42.0375 64.6125 43.3875C65.9625 44.7375 67.0312 46.325 67.8187 48.15C68.6062 49.975 69 51.925 69 54C69 55.95 68.6562 57.775 67.9688 59.475C67.2812 61.175 66.3375 62.7 65.1375 64.05C64.9375 64.275 64.675 64.3875 64.35 64.3875C64.025 64.3875 63.75 64.275 63.525 64.05C63.325 63.85 63.225 63.5938 63.225 63.2812C63.225 62.9688 63.325 62.6875 63.525 62.4375C64.55 61.3125 65.3438 60.0375 65.9062 58.6125C66.4688 57.1875 66.75 55.65 66.75 54C66.75 50.45 65.5125 47.4375 63.0375 44.9625C60.5625 42.4875 57.55 41.25 54 41.25C50.45 41.25 47.4375 42.4875 44.9625 44.9625C42.4875 47.4375 41.25 50.45 41.25 54C41.25 55.65 41.5312 57.1875 42.0938 58.6125C42.6562 60.0375 43.45 61.3125 44.475 62.4375C44.675 62.6875 44.775 62.9688 44.775 63.2812C44.775 63.5938 44.6625 63.8625 44.4375 64.0875C44.2125 64.3125 43.9437 64.4188 43.6313 64.4062C43.3188 64.3937 43.0625 64.275 42.8625 64.05ZM47.1 59.8125C46.45 59.0125 45.9375 58.125 45.5625 57.15C45.1875 56.175 45 55.125 45 54C45 51.5 45.875 49.375 47.625 47.625C49.375 45.875 51.5 45 54 45C56.5 45 58.625 45.875 60.375 47.625C62.125 49.375 63 51.5 63 54C63 55.125 62.8125 56.175 62.4375 57.15C62.0625 58.125 61.55 59.0125 60.9 59.8125C60.7 60.0375 60.4375 60.15 60.1125 60.15C59.7875 60.15 59.5125 60.0375 59.2875 59.8125C59.0875 59.6125 58.9875 59.3625 58.9875 59.0625C58.9875 58.7625 59.0875 58.475 59.2875 58.2C59.7625 57.625 60.125 56.9812 60.375 56.2687C60.625 55.5562 60.75 54.8 60.75 54C60.75 52.125 60.0938 50.5312 58.7812 49.2188C57.4688 47.9062 55.875 47.25 54 47.25C52.125 47.25 50.5312 47.9062 49.2188 49.2188C47.9062 50.5312 47.25 52.125 47.25 54C47.25 54.8 47.375 55.5562 47.625 56.2687C47.875 56.9812 48.2375 57.625 48.7125 58.2C48.9125 58.475 49.0125 58.7625 49.0125 59.0625C49.0125 59.3625 48.9 59.625 48.675 59.85C48.45 60.075 48.1812 60.1812 47.8687 60.1687C47.5562 60.1562 47.3 60.0375 47.1 59.8125ZM54 69C53.675 69 53.4062 68.8938 53.1937 68.6813C52.9812 68.4688 52.875 68.2 52.875 67.875V56.775C52.325 56.55 51.875 56.1875 51.525 55.6875C51.175 55.1875 51 54.625 51 54C51 53.175 51.2937 52.4687 51.8812 51.8812C52.4687 51.2937 53.175 51 54 51C54.825 51 55.5312 51.2937 56.1188 51.8812C56.7063 52.4687 57 53.175 57 54C57 54.625 56.825 55.1875 56.475 55.6875C56.125 56.1875 55.675 56.55 55.125 56.775V67.875C55.125 68.2 55.0188 68.4688 54.8063 68.6813C54.5938 68.8938 54.325 69 54 69Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8312 11.6603C53.8312 10.7433 53.0875 9.99667 52.1713 10.0319C44.0839 10.3424 36.2271 12.9169 29.4799 17.4854C22.2719 22.3658 16.6539 29.3026 13.3364 37.4185C10.019 45.5344 9.15097 54.4649 10.8422 63.0806C12.4254 71.1458 16.1845 78.5961 21.6867 84.6107C22.3073 85.289 23.3659 85.287 24.0117 84.6326C24.6455 83.9904 24.6428 82.9602 24.0351 82.2932C18.9741 76.7388 15.5156 69.8682 14.0561 62.4328C12.4913 54.4612 13.2944 46.1983 16.3639 38.6892C19.4333 31.18 24.6313 24.7619 31.3004 20.2463C37.5087 16.0428 44.7322 13.6637 52.1713 13.355C53.0874 13.3169 53.8312 12.5772 53.8312 11.6603Z",
    fill: "url(#paint2_linear_12145_1659)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12145_1659",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0823529 0 0 0 0 0.196078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12145_1659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12145_1659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12145_1659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55) rotate(89.2559) scale(45.0038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762092,
    stopColor: "#0D116B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12145_1659",
    x1: 28.7013,
    y1: 19.9351,
    x2: 52.6623,
    y2: 54.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E61D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E62D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12145_1659",
    x1: 53.8312,
    y1: 10,
    x2: 25.7877,
    y2: 86.8736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.c2a149bf157866fef9824e4cdfd61e7c.svg";
export { ForwardRef as ReactComponent };